// extracted by mini-css-extract-plugin
module.exports = {"ManageContentModule":"ManageCopyTable_ManageContentModule__3u4Md","AssociatedCampaigns":"ManageCopyTable_AssociatedCampaigns__3bw9I"};